import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { useLocale } from 'shared/hooks/useLocale';
import { usePrevious } from 'shared/hooks/usePrevious';

import { useAppReload } from './AppReloadProvider';
import { useSessionValue } from './useSession';

export const useSessionChangeHandler = () => {
  const session = useSessionValue();
  const prevSession = usePrevious(session);
  const locale = useLocale();
  const prevLocale = usePrevious(locale);
  const appReload = useAppReload();
  const queryClient = useQueryClient();

  useEffect(() => {
    const isLoggedIn = session && !prevSession;

    if (isLoggedIn) {
      return;
    }

    const isLoggedOut = !session && prevSession;
    const isCustomerChanged =
      session && prevSession && session.customer.id !== prevSession.customer.id;
    const isLocaleChanged = locale !== prevLocale;

    if (isLoggedOut || isCustomerChanged || isLocaleChanged) {
      queryClient.clear();
      if (appReload.length) {
        appReload();
      }
    }
  }, [appReload, locale, prevLocale, prevSession, queryClient, session]);
};
